import React from 'react';
import { Card, Form, Button } from 'react-bootstrap';

export const SessionDetails = ({ 
  selectedSlot, 
  subject,
  updateSlotSubject, 
  updateSlotProficiency, 
  optionalMessage, 
  setOptionalMessage, 
  handleBookSlot,
  isBookingLoading,
  isReschedule = false // Add this prop
}) => {
  if (!selectedSlot) return null;

  const proficiencyLevels = [
    "Beginner",
    "Elementary", 
    "Intermediate",
    "Upper-Intermediate",
    "Advanced"
  ];
  
  return (
    <div>
      <Card>
        <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
          {!isReschedule && (
            <>
              <h5 className="mb-3">Session Details</h5>
              <Form.Group className="mb-3">
                <Form.Label>
                  <i className="bi bi-book me-1"></i> Subject
                </Form.Label>
                  <div className="d-flex flex-wrap gap-2">
                    <Button
                      variant='primary'
                      onClick={() => updateSlotSubject(subject)}
                    >
                      {subject}
                    </Button>
                  </div>
              </Form.Group>
            </>
          )}

          {!isReschedule && (
            <>
              <Form.Group className="mb-3">
                <Form.Label>
                  <i className="bi bi-graph-up me-1"></i> Your Proficiency Level
                </Form.Label>
                <div className="border rounded p-3">
                  {proficiencyLevels.map((level) => (
                    <Form.Check
                      key={level}
                      type="radio"
                      id={`proficiency-${level}`}
                      name="proficiency"
                      label={level}
                      value={level}
                      checked={selectedSlot.proficiency === level}
                      onChange={(e) => updateSlotProficiency(level)}
                      className="mb-2"
                    />
                  ))}
                </div>
              </Form.Group>

              <Form.Group>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Any message you'd like to share with your tutor? (Optional)"
                  value={optionalMessage}
                  onChange={(e) => setOptionalMessage(e.target.value)}
                />
              </Form.Group>
            </>
          )}
          <div className="mt-3">
            <button
              className={`btn ${isReschedule ? 'btn-warning' : 'btn-primary'} w-100`}
              onClick={handleBookSlot}
              disabled={isBookingLoading}
            >
              {isBookingLoading 
                  ? (isReschedule ? 'Rescheduling...' : 'Booking...') 
                  : (isReschedule ? 'RESCHEDULE SESSION' : 'BOOK SESSION')
              }
            </button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};